let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("FCtEb")).then(() => parcelRequire('3tKFs'));